import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../../utils/BodyWrap";
import ContentDiv from "../../utils/ContentDiv";
import GeneralLoader from "../../GeneralLoader";
import ErrorText from "../../utils/error-success/ErrorText";
import DocumentGroup from "./DocumentGroup";

// State
import { getTranslations } from "../../../store/actions/translations";
import { getTrainingDocs } from "../../../store/actions/trainingDocs";

class TrainingDocs extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["training_documents"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		let resDocs = store !== null ? getTrainingDocs() : props.getTrainingDocs();
		promises.push(resDocs);

		return promises;
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			TrainingDocs.initialAction(null, this.props);
		}
	}

	render() {
		const { translationsLoading, translations, documents, isLoading, docErrors } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							{translationsLoading ? (
								<GeneralLoader />
							) : !!translations.pages[this.props.translationKey] ? (
								<ContentDiv>
									{translations.pages[this.props.translationKey].content}
								</ContentDiv>
							) : null}
						</div>

						{isLoading ? (
							<div className="section-row section-row--block">
								<GeneralLoader />
							</div>
						) : docErrors ? (
							<div className="section-row section-row--block">
								<ErrorText animate={1} errors={docErrors} />
							</div>
						) : (
									<React.Fragment>
										{documents.length ? (
											documents.map((group, i) => (
												<DocumentGroup key={i} group={group} />
											))
										) : (
												<div>
													{
														translations.sections.training_documents
															.no_results_response
													}
												</div>
											)}
									</React.Fragment>
								)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		isLoading: state.trainingDocs.isLoading === undefined ? 1 : state.trainingDocs.isLoading,
		docErrors: state.trainingDocs.error === undefined ? null : state.trainingDocs.error,
		documents: state.trainingDocs.documents === undefined ? [] : state.trainingDocs.documents
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getTrainingDocs }
)(TrainingDocs);



// WEBPACK FOOTER //
// ./src/components/training/documents/TrainingDocs.js